<input #vatnumber  type="text" class="form-control form-control-sm " [class.is-invalid]="vat_number && !verifyVATNumber()" [class.is-valid]="verifyVATNumber()" required 
name="{{name}}" #{{name}}="ngModel" [(ngModel)]="vat_number" title="{{vat_number_error}}"   (keyup)="onKeyChange()">
